import { render, staticRenderFns } from "./FolderCreate.vue?vue&type=template&id=0ceb30ba&scoped=true&"
import script from "./FolderCreate.vue?vue&type=script&lang=js&"
export * from "./FolderCreate.vue?vue&type=script&lang=js&"
import style0 from "./FolderCreate.vue?vue&type=style&index=0&id=0ceb30ba&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceb30ba",
  null
  
)

export default component.exports